export const SalesCard = {
  noData: {
    message: '集計データがありません。',
  },
} as const;
